export default value => Math.round(value * 100) / 100;
